import { PlatePluginOptions } from '@udecode/plate-core';

export const MARK_UNDERLINE = 'underline';

export const DEFAULTS_UNDERLINE: Partial<PlatePluginOptions> = {
  hotkey: 'mod+u',
};
